<template>
    <div>
        <rkm-row>

            <rkm-col cols="6">
                <rkm-area
                    title="Relação de parentesco com o responsável familiar"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-select
                                :options="data.form.parentesco"
                                :label="false"
                                show-default-option
                                text-field="descricao"
                                v-model="data.model.informacao.parentescoResponsavelId"
                                default-option-text="Selecione"
                                value-field="id"
                                :disabled="data.model.cidadao.responsavel"
                                class="pt-0"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Ocupação"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-input-autocomplete
                                :searchFields="localForm.autocompleteFields.ocupacao"
                                :repository="repositories.ocupacao"
                                v-model="data.model.informacao.ocupacao"
                                :textField="l => `${l.codigo} - ${l.nome}`"
                                :validations="validations.ocupacao"
                                uppercase
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    title="Qual é o curso mais elevado que frequenta ou frequentou?"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-select
                                :options="data.form.curso"
                                :label="false"
                                show-default-option
                                text-field="descricao"
                                v-model="data.model.informacao.cursoId"
                                default-option-text="Selecione"
                                value-field="id"
                                class="pt-0"
                            >
                                <rkm-input-group-append slot="append">
                                    <rkm-input-group-text>
                                        <rkm-form-checkbox
                                            v-model="data.model.informacao.frequentaEscolaCreche"
                                        >
                                            Frequenta escola ou creche
                                        </rkm-form-checkbox>
                                    </rkm-input-group-text>
                                </rkm-input-group-append>
                            </rkm-form-select>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Situação no mercado de trabalho"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-select
                                :options="data.form.mercadoTrabalho"
                                :label="false"
                                show-default-option
                                text-field="descricao"
                                v-model="data.model.informacao.situacaoMercadoTrabalhoId"
                                default-option-text="Selecione"
                                value-field="id"
                                class="pt-0"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-area
                    title="Frequenta cuidador tradicional?"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-radio-group
                                v-model="data.model.informacao.frequentaCuidadorTradicional"
                                :label="false"
                                class="pt-0"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-area
                    title="Participa de grupo comunitário?"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-radio-group
                                v-model="data.model.informacao.participaGrupoComunitario"
                                :label="false"
                                class="pt-0"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    title="CRIANÇAS DE 0 A 9 ANOS, COM QUEM FICA?"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="12">
                            <rkm-form-checkbox-group
                                :options="data.form.acompanhamentoInfantil"
                                class="mx-2"
                                name="criancas"
                                text-field="descricao"
                                v-model="data.model.informacao.acompanhamentoInfantil"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-area
                    title="Plano de saúde privado"
                    no-margin-top
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-radio-group
                                v-model="data.model.informacao.planoSaude"
                                label="Possui?"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="9">
                <rkm-area
                    title="Povo ou comunidade tradicional?"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="4">
                            <rkm-form-radio-group
                                v-model="data.model.informacao.comunidadeTradicional"
                                label="É membro?"
                                @change="resetComunidadeTradicionalQual()"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>

                        <rkm-col cols="8">

                            <rkm-form-input-autocomplete
                                :searchFields="localForm.autocompleteFields.comunidade"
                                :repository="repositories.cadastroIndividual.comunidade"
                                v-model="data.model.informacao.comunidadeTradicionalQual"
                                textField="descricao"
                                :validations="data.model.informacao.comunidadeTradicional ? validations.comunidadeTradicional : {}"
                                :disabled="!data.model.informacao.comunidadeTradicional"
                                label="Qual?"
                                uppercase
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Orientação sexual"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="4">
                            <rkm-form-radio-group
                                v-model="data.model.informacao.orientacaoSexual"
                                label="Deseja informar?"
                                @change="resetOrientacaoSexual()"
                                :validations="validations.orientacaoSexual"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>

                        <rkm-col cols="8">
                            <rkm-form-select
                                :options="data.form.orientacaoSexual"
                                label="Orientação sexual"
                                show-default-option
                                text-field="descricao"
                                v-model="data.model.informacao.orientacaoSexualId"
                                default-option-text="Selecione"
                                value-field="id"
                                :disabled="!data.model.informacao.orientacaoSexual"
                                :validations="data.model.informacao.orientacaoSexual ? validations.orientacaoSexual : {}"
                                class="uppercase-options"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="6">
                <rkm-area
                    title="Identidade de gênero"
                    no-margin-top
                >

                    <rkm-row>

                        <rkm-col cols="4">
                            <rkm-form-radio-group
                                v-model="data.model.informacao.identidadeGenero"
                                label="Deseja informar?"
                                @change="resetIdentidadeGenero()"
                                :validations="validations.identidadeGenero"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>

                        <rkm-col cols="8">
                            <rkm-form-select
                                :options="data.form.identidadeGenero"
                                label="Identidade de gênero"
                                show-default-option
                                text-field="descricao"
                                v-model="data.model.informacao.identidadeGeneroId"
                                default-option-text="Selecione"
                                value-field="id"
                                :disabled="!data.model.informacao.identidadeGenero"
                                :validations="data.model.informacao.identidadeGenero == true ? validations.identidadeGenero : {}"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    title="Deficiência"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-radio-group
                                v-model="data.model.informacao.deficiente"
                                label="Tem alguma?"
                                @change="resetDeficiencias()"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-checkbox-group
                                :options="data.form.deficiencia"
                                label="Quais?"
                                name="deficiencias"
                                text-field="descricao"
                                v-model="data.model.informacao.deficiencias"
                                value-field="id"
                                :disabled="!data.model.informacao.deficiente"
                                :validations="data.model.informacao.deficiente == true ? validations.deficiencia : {}"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    title="Saída do cidadão do cadastro"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="data.form.saidaCidadao"
                                label="Motivo"
                                show-default-option
                                text-field="descricao"
                                v-model="data.model.informacao.saidaCidadaoId"
                                default-option-text="Selecione"
                                value-field="id"
                                @change="handleMotivoSaida"
                                :disabled="data.model.informacao.obito && data.model.informacao.saidaCidadaoId == enums.saidaCidadao.OBITO"
                            />
                        </rkm-col>

                        <rkm-col cols="6" v-if="data.model.informacao.saidaCidadaoId == enums.saidaCidadao.MUDANCA_DE_TERRITORIO">

                            <rkm-form-date-picker
                                label="Data"
                                :max-date="data.form.dataAtual"
                                v-model="data.model.informacao.motivoSaidaData"
                                :validations="data.model.informacao.saidaCidadaoId == enums.saidaCidadao.MUDANCA_DE_TERRITORIO ? validations.motivoSaidaData : {}"
                                right
                            />
                        </rkm-col>

                        <rkm-col v-if="data.model.informacao.saidaCidadaoId == enums.saidaCidadao.OBITO">

                            <rkm-form-date-picker
                                label="Data de óbito"
                                :max-date="data.form.dataAtual"
                                v-model="data.model.informacao.obitoEm"
                                :min-date="dataDocumento"
                                :validations="data.model.informacao.saidaCidadaoId == enums.saidaCidadao.OBITO ? validations.motivoSaidaData : {}"
                                :disabled="data.model.informacao.obito"
                                right
                            />
                        </rkm-col>

                        <rkm-col v-if="data.model.informacao.saidaCidadaoId == enums.saidaCidadao.OBITO">
                            <rkm-form-time-picker
                                :validations="data.model.informacao.saidaCidadaoId == enums.saidaCidadao.OBITO ? validations.horaObito : {}"
                                label="Hora de óbito"
                                v-model="data.model.informacao.horaObito"
                                :disabled="data.model.informacao.obito"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="data.model.informacao.saidaCidadaoId == enums.saidaCidadao.OBITO">
                        <rkm-col>
                            <rkm-form-input
                                label="Número da declaração de óbito"
                                v-model="data.model.informacao.obitoDeclaracao"
                                :validations="data.model.informacao.saidaCidadaoId == enums.saidaCidadao.OBITO ? validations.obitoDeclaracao : {}"
                                :disabled="data.model.informacao.obito"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input-autocomplete
                                :searchFields="fields.autocomplete.obito.cid"
                                :repository="repositories.cid"
                                label="CID10"
                                placeholder="CID10 referente a causa do óbito"
                                v-model="data.model.informacao.obitoCid"
                                :disabled="data.model.informacao.obito"
                            >
                                <template v-slot:itemLabel="{ item }">
                                    {{ item.codigo | formatCid }} - {{ item.nome }}
                                </template>
                            </rkm-form-input-autocomplete>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="data.model.informacao.saidaCidadaoId == enums.saidaCidadao.OBITO">
                        <rkm-col>
                            <rkm-form-textarea
                                label="Causa do óbito"
                                v-model="data.model.informacao.obitoCausa"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <ModalObito ref="ModalObito" :data="data" />
        <ModalTerritorio ref="ModalTerritorio" :data="data" />
    </div>
</template>

<script>
// Components.
import ModalTerritorio from './components/territorio/Modal'
import ModalObito from './components/obito/Modal'

//Enums
import saidaCidadao from '@/enums/atencao-basica/saidaCidadao'
import deficiencia from '@/enums/cadastro/cidadao/deficienciaBase'
import fatorRisco from '@/enums/cadastro/cidadao/fatorRisco'

// Filters.
import formats from '@/filters/formats'

// Mixins
import { repository, object, data } from '@/mixins'

export default {
    components: { ModalTerritorio, ModalObito },
    computed: {
        validations() {

            return {
                deficiencia: {
                    required: true,
                },
                orientacaoSexual: {
                    required: true,
                },
                identidadeGenero: {
                    required: true,
                },
                motivoSaidaData: {
                    required: true,
                },
                comunidadeTradicional: {
                    required: true,
                },
                horaObito: { required: true },
                obitoDeclaracao: { min: 9, max: 9 },
            }
        },
        dataDocumento() {

            const datasExistentes = [];

            if (this.data.model.informacao.dataEntrada) {
                datasExistentes.push(new Date(this.data.model.informacao.dataEntrada));
            }

            if (this.data.model.informacao.dataNaturalizacao) {
                datasExistentes.push(new Date(this.data.model.informacao.dataNaturalizacao));
            }

            if (this.data.model.cidadao.dataNascimento) {
                datasExistentes.push(new Date(this.data.model.cidadao.dataNascimento));
            }

            if (datasExistentes.length > 0) {

                const dataMaisRecente = new Date(Math.max(...datasExistentes));
                return this.getFormatedDate(dataMaisRecente, 'DD/MM/YYYY')
            }

            return null
        },
    },
    created() {
        this.repositories.cid = this.getConectaSusRepository('sigtap.cid')
        this.repositories.ocupacao = this.getConectaSusRepository('sigtap.ocupacao')
        this.repositories.cadastroIndividual = this.getConectaSusRepository('atencaoBasica.cadastroIndividual')
    },
    data: () => ({
        enums: {
            saidaCidadao,
            deficiencia,
            fatorRisco,
        },
        fields: {
            autocomplete: {
                obito: {
                    cid: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true },
                    ],
                },
            },
        },
        repositories: {},
        localForm: {
            autocompleteFields: {
                ocupacao: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
                comunidade: [
                    { key: 'codigoEsus', searchable: true },
                    { key: 'descricao', searchable: true },
                ],
            },
        },
    }),
    methods: {
        resetComunidadeTradicionalQual() {

            if (!this.data.model.informacao.comunidadeTradicional) {
                this.data.model.informacao.comunidadeTradicionalQual = null
            }
        },
        resetIdentidadeGenero() {

            if (!this.data.model.informacao.identidadeGenero) {
                this.data.model.informacao.identidadeGeneroId = null
            }
        },
        resetOrientacaoSexual() {

            if (!this.data.model.informacao.orientacaoSexual) {
                this.data.model.informacao.orientacaoSexualId = null
            }
        },
        resetDeficiencias() {

            if (!this.data.model.informacao.deficiente) {
                this.data.model.informacao.deficiencias = []
            }
        },
        handleMotivoSaida() {

            if (this.data.model.informacao.saidaCidadaoId == this.enums.saidaCidadao.OBITO
                && this.data.model.cidadao.responsavel && this.data.form.responsaveis.length > 0) {

                    this.showConfirmation(
                        'O paciente atualmente está registrado como responsável familiar. '
                            + 'Ao registrar o óbito, ele será removido como responsável familiar, e será necessário '
                            + 'informar outro membro da família como responsável. Deseja continuar?',
                            async () => this.data.model.cidadao.responsavel = false,
                            async () => this.data.model.informacao.saidaCidadaoId = null,
                    )
            } else if (this.data.model.informacao.saidaCidadaoId == this.enums.saidaCidadao.OBITO
                && this.data.model.cidadao.responsavel && this.data.form.residentes.length > 0) {

                    this.$refs.ModalObito.open()

            } else if (this.data.model.informacao.saidaCidadaoId == this.enums.saidaCidadao.MUDANCA_DE_TERRITORIO) {

                this.$emit('mudanca-territorio')

                this.showConfirmation(
                    'A classificação do paciente será alterada para "Provisório", e as informações de endereço do '
                        + 'cadastro do paciente serão perdidas. Deseja continuar?',
                        async () => this.$nextTick().then(() => this.handleDomiciliados()),
                        async () => this.data.model.informacao.saidaCidadaoId = null,
                )
            }
        },
        handleDomiciliados() {

            if (this.data.form.residentes.length > 0) {

                this.$refs.ModalTerritorio.open()
            }
        }
    },
    filters: {
        ...formats,
    },
    mixins: [ repository, object, data ],
    props: {
        data: { type: Object, required: false },
    },
    watch: {
        'data.model.informacao.deficiencias': function (newValue, oldValue) {

            if (newValue !== oldValue) {

                if (newValue) {

                    const fatorRiscoHasTea = this.data.model.fatoresRisco.find(item => item.id == this.enums.fatorRisco.TEA) ? true : false
                    const newHasTea = newValue.find(item => item == this.enums.deficiencia.TEA) ? true : false
                    const oldHasTea = oldValue.find(item => item == this.enums.deficiencia.TEA) ? true : false

                    if (fatorRiscoHasTea && !newHasTea && oldHasTea) {

                        const fn = async () => this.data.model.informacao.deficiencias.push(this.enums.deficiencia.TEA)

                        this.showConfirmation(
                            'O Transtorno do Espectro Autista será removido dos fatores de risco do paciente. Deseja continuar?',
                            async () => {},
                            fn,
                        )
                    }

                    if (!fatorRiscoHasTea && newHasTea && !oldHasTea) {

                        const fn = async () => {

                            const index = this.data.model.informacao.deficiencias.indexOf(this.enums.deficiencia.TEA)

                            if (index !== -1) {
                                this.data.model.informacao.deficiencias.splice(index, 1)
                            }
                        }

                        this.showConfirmation(
                            'O Transtorno do Espectro Autista será adicionado nos fatores de risco do paciente. Deseja continuar?',
                            async () => {},
                            fn,
                        )
                    }
                }
            }
        },
    }
}
</script>

<style>

.uppercase-options option {
    text-transform: uppercase!important;
}

</style>